import {
  Button,
  Card,
  Flex,
  Group,
  LoadingOverlay,
  SegmentedControl,
  TextInput,
} from "@mantine/core";
import { useEffect, useMemo, useRef, useState } from "react";
import TextEditor from "../../../../components/ExternalEditors/TextEditor";
import { getVariables } from "./resellerMessagesVariables";
import { IconDeviceFloppy } from "@tabler/icons-react";
import SendBAT from "../../models/emails/SendBAT";
import EmailModalPreview from "../../../../components/View/EmailModalPreview";
import {
  editMessagesReseller,
  getMessagesReseller,
} from "../../../../api/ResellerAPI";
import { useParams } from "react-router-dom";
import { cleanModel } from "../../models/emails/cleanModel";
import { notifications } from "@mantine/notifications";
import AddTokens from "../../../../components/Adder/AddTokens";
import { useLanguage } from "../../../../stores/LanguageStore";
import FilesModal from "../../files/FilesModal";
import { insertTextToInput } from "../../../../functions/utilFunctions";

const ResellersMessagesItem = ({ active }) => {
  const lang = useLanguage((s) => s.language);
  const { resellerId } = useParams();
  const editorRef = useRef();
  const [language, setLanguage] = useState("FRA");
  const [loading, setLoading] = useState(true);

  const datafieldTokens = useMemo(() => {
    return getVariables({ type: active });
  }, [active]);

  const [activeMessage, setActiveMessage] = useState(null);

  const handlePreview = ({ setHtml, setSubject, open }) => {
    const fd = new FormData(document.getElementById("message-form"));
    const data = Object.fromEntries(fd);

    setHtml(editorRef.current.getContent());
    setSubject(data.subject);
    open();
  };

  const [submitting, setSubmitting] = useState(false);
  const onSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    let html = editorRef?.current?.getContent();

    

    let requiredVariables = getVariables({ type: active, forRequired: true });
    let requiredVariablesNotFound = [];
    console.log(requiredVariables);

    requiredVariables.forEach((v) => {
      if (!html.includes(v.value)) {
        requiredVariablesNotFound.push(v.value);
      }
    });

    if (requiredVariablesNotFound.length > 0) {
      return notifications.show({
        message:
          lang.resellers.messages.required +
          requiredVariablesNotFound.map((x) => x).join(", "),
        color: "red",
      });
    }

    setSubmitting(true);
    editMessagesReseller({
      id: parseInt(resellerId),
      name: active,
      language,
      content: cleanModel(html),
      subject: data.subject,
    })
      .then((response) => {
        notifications.show({
          title: lang.resellers.messages.saved,
          message: lang.resellers.messages.saved_text,
          color: "tertiary.8",
        });
      })
      .finally(() => setSubmitting(false)).finall;
  };

  useEffect(() => {
    setLoading(true);
    getMessagesReseller(resellerId)
      .then((res) =>
        setActiveMessage(
          // Find message for the reseller or, if not found, use the default message
          res.data.messages.find(
            (x) =>
              x.name === active &&
              x.language === language &&
              x.reseller_id === parseInt(resellerId)
          ) ||
            res.data.messages.find(
              (x) =>
                x.name === active &&
                x.language === language &&
                x.reseller_id === null
            )
        )
      )
      .finally(() => setLoading(false));
  }, [active, language, resellerId]);

  return (
    <Card
      flex={1}
      id="message-form"
      component="form"
      onSubmit={onSubmit}
      pos={"relative"}
    >
      <LoadingOverlay visible={submitting} />
      <SegmentedControl
        data={[
          { label: "Français", value: "FRA" },
          { label: "English", value: "ENG" },
        ]}
        value={language}
        onChange={setLanguage}
        size="md"
        mb={8}
      />
      {loading ? (
        <LoadingOverlay visible={submitting || loading} />
      ) : (
        <>
          <TextInput
            label={lang.resellers.messages.subject}
            size="md"
            defaultValue={activeMessage?.subject}
            styles={{ input: { background: "#fff" } }}
            id="message-subject"
            name="subject"
            mb={16}
            rightSection={
              <AddTokens
                items={datafieldTokens}
                handleAdd={(item) => {
                  let input = document.getElementById("message-subject");
                  insertTextToInput(
                    `{${item?.value.replaceAll("%", "")}}`,
                    input
                  );
                }}
              />
            }
          />

          {activeMessage && (
            <TextEditor
              editorRef={editorRef}
              placeholder={lang.resellers.messages.message_placeholder}
              tokens={datafieldTokens}
              height={250}
              onInit={(editor) => {
                if (activeMessage) editor.setContent(activeMessage?.content);
              }}
              longVariableButton
            >
              <Group
                wrap="nowrap"
                style={{
                  position: "absolute",
                  top: 8,
                  left: 132,
                  zIndex: 4,
                }}
              >
                <FilesModal editorRef={editorRef} isLongButton />
              </Group>
            </TextEditor>
          )}

          <Group justify="space-between" mt={"sm"}>
            <Flex gap={16}>
              <EmailModalPreview
                getData={handlePreview}
                disableEdit
                noSign
                size="md"
                otherTokens={getVariables({ type: active }).map((x) => ({
                  ...x,
                  identifier_placeholder: x.value,
                }))}
              />
              <SendBAT
                getModel={async () => {
                  let subject =
                    document.getElementById("email-subject")?.value ||
                    "no_subject";
                  let html = "";
                  let text = "";

                  html = editorRef?.current?.getContent();
                  text =
                    editorRef?.current?.getContent({ format: "text" }) ||
                    "text";

                  return {
                    subject,
                    html,
                    text,
                  };
                }}
                size="md"
                noSign
              />
            </Flex>
            <Flex gap={"md"} ml={"auto"}>
              <Button
                type="submit"
                leftSection={<IconDeviceFloppy size={18} />}
                id="form-submitter"
                size="md"
              >
                {lang.resellers.messages.submit}
              </Button>
            </Flex>
          </Group>
        </>
      )}
    </Card>
  );
};

export default ResellersMessagesItem;
